module.exports = __webpack_public_path__ + "static/media/jam-villanueva.6af23aa1.jpg";